import type { WeeklyAvailability, WorkDay } from '../../api/generated';
import {
  DAY_ORDER,
  DEFAULT_END_TIME,
  DEFAULT_START_TIME,
  DEFAULT_WORKING_DAYS
} from './staffScheduleConstants';
import type { DayKey, WeekScheduleForm } from './staffScheduleConstants';

// API stores LocalTime as 'HH:mm:ss'; the HTML time input works with 'HH:mm'.
const toInputTime = (value: string | undefined, fallback: string): string =>
  value && value.length >= 5 ? value.slice(0, 5) : fallback;

const toApiTime = (value: string): string => (value.length === 5 ? `${value}:00` : value);

export const createDefaultWeekSchedule = (): WeekScheduleForm => {
  const result = {} as WeekScheduleForm;
  for (const day of DAY_ORDER) {
    result[day] = {
      enabled: DEFAULT_WORKING_DAYS.includes(day),
      startTime: DEFAULT_START_TIME,
      endTime: DEFAULT_END_TIME
    };
  }
  return result;
};

export const availabilityToWeekSchedule = (
  availability: WeeklyAvailability | undefined
): WeekScheduleForm => {
  const weekSchedule = availability?.weekSchedule ?? {};
  const result = {} as WeekScheduleForm;
  for (const day of DAY_ORDER) {
    const workDay: WorkDay | undefined = weekSchedule[day];
    result[day] = workDay
      ? {
          enabled: true,
          startTime: toInputTime(workDay.startTime, DEFAULT_START_TIME),
          endTime: toInputTime(workDay.endTime, DEFAULT_END_TIME)
        }
      : { enabled: false, startTime: DEFAULT_START_TIME, endTime: DEFAULT_END_TIME };
  }
  return result;
};

export const weekScheduleToAvailability = (form: WeekScheduleForm): WeeklyAvailability => {
  const weekSchedule: Record<string, WorkDay> = {};
  for (const day of DAY_ORDER) {
    const daySchedule = form[day];
    if (daySchedule.enabled) {
      weekSchedule[day] = {
        startTime: toApiTime(daySchedule.startTime),
        endTime: toApiTime(daySchedule.endTime)
      };
    }
  }
  return { weekSchedule };
};

export const getEnabledDays = (form: WeekScheduleForm): DayKey[] =>
  DAY_ORDER.filter((day) => form[day].enabled);
